
import { defineComponent, PropType } from "vue";
import { IUser } from "@/services/Models";

export default defineComponent({
  name: "AdminContractUserItem",
  props: {
    item: { type: Object as PropType<IUser> },
    isHeader: { type: Boolean },
  },
  setup(props, context) {
    return {
      context,
    };
  },
});
